<template>
  <div class="messageServerDialog">
    <el-dialog :visible.sync="isShow" width="441px" class="messageDialog" title="直播即将开始时将短信通知您" :close-on-click-modal="false">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item prop="phone">
          <el-input v-model="form.phone" maxlength="11" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <el-input
            v-model="form.captcha"
            maxlength="8"
            placeholder="请输入验证码"
          >
          <template slot="suffix">
            <el-button
            v-if="!isSending"
              :disabled="isSending"
              @click="getCaptcha"
              class="btn"
            >获取验证码</el-button>
            <span v-if="isSending" style="width: 120px;color: #999999;display: inline-block;text-align: right;">重新发送（{{ captchaTime }}s）</span>
          </template>
        </el-input>
        </el-form-item>
      </el-form>
      <div class="protocol">
        <el-checkbox v-model="protocolChecked"></el-checkbox>
        <p>我已阅读并同意<span @click="showAgreementDialog = true">《信息采集声明》</span></p>
      </div>
      <div class="submitBox">
        <el-button round @click="close()" class="cancel">取消</el-button>
        <el-button round class="submit"  @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showAgreementDialog"
      class="agreementDialog"
      width="448px"
    >
      <div class="agreementContent">
        <p class="title">信息采集声明</p>
        <div class="con">
          <p>
            珊瑚课堂用户（以下简称“您”）在使用湖南腾速科技有限公司（以下简称“珊瑚课堂”）发起的信息采集功能时，请务必认真阅读、理解并接受本声明的全部内容，特别是加粗或重点标注的部分。一旦您开始使用此功能并点击保存提交，即表示您已同意珊瑚课堂在本声明项下的所有条款。若您对本声明内容有任何异议，请避免使用此功能。
          </p>
          <p>
            1.本功能由珊瑚课堂发起，您已仔细阅读并明确知晓信息采集页面所展示的信息采集目的及所涉及的信息类型。
          </p>
          <p>
            2.您明确同意并授权珊瑚课堂仅在为您提供服务的必要范围内使用并保留您所提供的个人信息，且使用时间不得超过信息预定使用目的所必需的期限，或合同及法律所规定的时限。
          </p>
          <p>
            3.您承诺，通过本功能向珊瑚课堂提交的所有信息（包括个人信息）均系您本人真实意愿的表达。
          </p>
          <p>
            4.您已了解，即使您已通过本功能提交了个人信息，您仍有权随时要求珊瑚课堂删除这些信息。若您提出停止使用或删除个人信息的要求，而珊瑚课堂未在合理期限内予以执行，您有权依法追究其相应责任。
          </p>
          <p>
            我们始终致力于保护您的个人信息安全，并尊重您的合法权益。
          </p>
          <p>
            请您放心使用，如有任何疑问或需要帮助，请随时与我们联系。
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tool from '@/kits/Tools.js'
import qs from 'qs'
export default {
  name: 'messageServerDialog',
  props: ['dialogVisible', 'dsId', 'uid', 'fansId', 'channelId', 'appointmentData'],
  data () {
    return {
      form: {
        phone: '',
        captcha: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      protocolChecked: false,
      isSending: false,
      captchaTime: 60,
      captchaInterval: null,
      // 协议内容
      showAgreementDialog: false
    }
  },
  computed: {
    isShow: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    }
  },
  methods: {
    getCaptcha () {
      if (this.isSending) return

      const postData = {
        phone: this.form.phone,
        org_id: this.uid
      }
      this.axios.post(
        tool.baseUrlSchool() + '/common/index/sendSms',
        qs.stringify(postData)
      ).then(res => {
        if (res.data.code === 200) {
          // 禁用获取验证码按钮并开始倒计时
          this.isSending = true
          this.captchaTime = 60
          this.captchaInterval = setInterval(() => {
            if (this.captchaTime > 0) {
              this.captchaTime--
            } else {
              clearInterval(this.captchaInterval)
              this.isSending = false
              this.captchaTime = 60
            }
          }, 1000)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    resetCaptcha () {
      // 对话框打开时重置验证码状态
      if (this.captchaInterval) {
        clearInterval(this.captchaInterval)
        this.captchaInterval = null
      }
      this.isSending = false
      this.captchaTime = 60
    },
    submitForm () {
      console.log(this.fansId)
      // 在这里实现表单提交的逻辑
      // 可以进行表单验证，然后发送请求到后端进行数据处理
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.protocolChecked) {
            this.$message({
              type: 'warning',
              message: '请选择并确认协议'
            })
            return
          }
          const postData = {
            phone: this.form.phone,
            org_id: this.uid,
            code: this.form.captcha
          }
          // 验证验证码
          this.axios.post(
            tool.baseUrlSchool() + '/common/index/checkSms',
            qs.stringify(postData)
          ).then(res => {
            if (res.data.code === 200) {
              // 绑定手机号
              var option = 'fans_id=' + this.fansId + '&phone=' + this.form.phone
              this.axios.post(tool.baseUrl4() + '/user/editphone', option).then(req => {
                if (req.data.code === 200) {
                  this.getSubscribe()
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          console.log('表单验证失败！')
          return false
        }
      })
    },
    // 预约操作
    getSubscribe () {
      var data = this.appointmentData
      var option = `ds_id=${this.dsId}&fans_id=${this.fansId}&url=${location.href}&class_time=${data.class_time || ''}&flag=${data.flag}&dates=${data.dates || ''}&type=${data.type}&dsb_id=${data.id}&org_id=${this.uid}`
      this.axios.post(tool.baseUrl4() + '/user/fansBook', option).then(res => {
        if (res.data.code === 200) {
          this.$message.success('预约成功')
          this.$nextTick(() => {
            this.reset()
          })
          this.close('success')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 重置
    reset () {
      this.form = {
        phone: '',
        captcha: ''
      }
      this.protocolChecked = false
      this.isSending = false
      this.captchaTime = 60
      this.captchaInterval = null
      this.showAgreementDialog = false
    },
    close (type = 'fail') {
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
      this.$emit('close', {type})
    }
  }
}
</script>

<style scoped>

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: rgba(24,114,237,1);
}
/deep/ .el-dialog__body {
  padding: 20px 0;
}
/deep/ .el-form {
  padding: 0 20px;
}
/deep/ .el-checkbox__inner {
  border-radius: 50%;
}
/deep/ .el-form-item__error {
  margin-left: 16px;
}
.messageDialog >>> .el-dialog__title  {
  font-size: 16px;
}
.protocol {
  margin-top: 30px;
  border-top: 1px solid #e6e9f0;
  padding: 16px 20px;
  display: flex;
  align-items: center;
}
.protocol p {
  margin-left: 8px;
  font-size: 14px;
  color: #202020;
}
.protocol p span {
  cursor: pointer;
  color: rgba(24,114,237,1);
}
.btn {
  background-color: transparent;
  border:none ;
  color: rgba(24,114,237,1) !important;
  padding-right: 10px;
}
.submitBox {
  width: 100%;
  display: flex;
  padding: 0 90px;
  margin-top: 4px;
  justify-content: space-between;
  box-sizing: border-box;
}
.cancel {
  width: 118px;
  height: 40px;
  color: #202020;
  background: #dfe3e8;
}
.submit {
  width: 118px;
  height: 40px;
  background: linear-gradient(110deg,#73aaff 0%, #0053ff 100%);
  color: #fff;
}
.agreementContent {
  padding: 0 24px 22px;
  font-size: 16px;
  word-break: break-all;
  word-wrap: break-word;
  text-align: justify;
  color: #202020;
}
.agreementContent .title {
  text-align: center;
  margin-bottom: 26px;
  font-weight: bold;
  font-size: 16px;
}
.agreementContent .con {
  line-height: 22px;
  font-size: 14px;
}
.agreementDialog .el-dialog {
  border-radius: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/messageServerDialog.vue